'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var paths = require('./paths.js');

var Svg = styled.svg.withConfig({
  componentId: "sc-19evb5x-0"
})(["width:", ";height:", ";vertical-align:", ";"], function (props) {
  return props.s.width || '4rem';
}, function (props) {
  return props.s.height || '4rem';
}, function (props) {
  return props.s.verticalAlign || 'middle';
});
var StoreIcon = function StoreIcon(_ref) {
  var s = _ref.s,
    className = _ref.className,
    fillColor = _ref.fillColor,
    outlineColor = _ref.outlineColor;
  return /*#__PURE__*/React.createElement(Svg, {
    s: s,
    className: className,
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: fillColor,
    d: paths.roofPattern
  }), /*#__PURE__*/React.createElement("rect", {
    fill: fillColor,
    x: "29.1",
    y: "34.6",
    width: "18.5",
    height: "10.2",
    rx: "1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: outlineColor,
    d: paths.storeWindow
  }), /*#__PURE__*/React.createElement("path", {
    fill: fillColor,
    d: paths.roofTop
  }), /*#__PURE__*/React.createElement("path", {
    fill: outlineColor,
    d: paths.storeOutline
  }));
};
StoreIcon.defaultProps = {
  s: {},
  className: '',
  fillColor: '#e8e8e8',
  outlineColor: '#231f20'
};
StoreIcon.propTypes = {
  fillColor: PropTypes.string,
  outlineColor: PropTypes.string,
  s: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
    verticalAlign: PropTypes.string
  }),
  className: PropTypes.string
};

exports.default = StoreIcon;
